import React from 'react';
import { INamedCohortBuilderInfoProps } from '../types';
import NamedCohortFetch from './NamedCohortFetch';
import NamedCohortInfo from './NamedCohortInfo';

export default (props: INamedCohortBuilderInfoProps) => {
  const { fetched } = props;

  if (!fetched) {
    return <NamedCohortFetch {...props} />;
  }

  return <NamedCohortInfo {...props} />;
};
